import * as React from "react";
import "./addComment.scss";
import AvatarDisplay from "./AvatarDisplay";
import CommentEditor from "./CommentEditor";
import { useDetailAddCommentState } from "./hooks/useDetailAddCommentState";

export default React.memo( function BasicTextFields({ cardId }) {
  const {
    anchorEl,
    comment,
    editorRef,
    elementPos,
    handleCancel,
    handleChange,
    handleComment,
    handleEditor,
    handleMention,
    handleMentionClose,
    handleSave,
    handleUserSelect,
    isDisable,
    isLoading,
    isMobile,
    mentionListVisible,
    name,
    selectedUserForTag,
    setElementPos,
    showEditor,
    tooltipName,
    user,
  } = useDetailAddCommentState(cardId);

  return (
    <>
      <div className="d-flex add-comment">
        <div>
          <AvatarDisplay user={user} name={name} tooltipName={tooltipName} />
        </div>
        {showEditor && (
          <CommentEditor
            comment={comment}
            handleComment={handleComment}
            handleMention={handleMention}
            editorRef={editorRef}
            isMobile={isMobile}
            setElementPos={setElementPos}
            mentionListVisible={mentionListVisible}
            anchorEl={anchorEl}
            elementPos={elementPos}
            handleMentionClose={handleMentionClose}
            isLoading={isLoading}
            handleChange={handleChange}
            selectedUserForTag={selectedUserForTag}
            handleUserSelect={handleUserSelect}
            handleSave={handleSave}
            handleCancel={handleCancel}
            isDisable={isDisable}
          />
        )}
        {!showEditor && (
          <div
            className="add-comment-field"
            onClick={handleEditor}>
            <p>Add a comment...</p>
          </div>
        )}
      </div>
    </>
  );
})
